export default __webpack_public_path__ + "static/media/ModernEra-Medium.07f0decd.woff";